import React from 'react';
import AuthScreens from '../components/AuthScreens/AuthScreens';

export default function AuthPage({ mode }) {
  return <AuthScreens mode={mode} />;
}
